// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"LearningType_reasonsContainer__n5RYL","header":"LearningType_header__dFQjs","noReasons":"LearningType_noReasons__LinvR"};